import { object, string } from 'yup';

export const linkAccountManuallySchema = object().shape({
  accountId: string()
    .matches(/^\d+$/, 'Should be a valid account ID, e.g. 123')
    .label('Account ID')
    .required(),
});
